// ============================================================
// FILE: src/pages/Industries.jsx  →  INDUSTRIES PAGE
// The 10 industry cards. Text is in src/data/site.js
// (INDUSTRIES LIST).
// ============================================================

import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { useSEO } from "../hooks/useSEO";
import { INDUSTRIES } from "../data/site";

export default function Industries() {
  useSEO("Industries We Serve — Evolve Trade & Logistics", "Food, retail, manufacturing, hospitality, construction, healthcare, automotive, government, wholesale and distribution trade programmes.");
  return (
    <>
      <PageHero
        label="Industries"
        title="Sector-specific trade,"
        accent="engineered to fit"
        description="Ten industries, ten different compliance regimes, packaging standards and buyer expectations. We speak all of them fluently."
        crumbs={[{ label: "Industries" }]}
      />
      <section className="pb-24 sm:pb-32" data-testid="industries-grid">
        <div className="container-x">
          <Stagger className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {INDUSTRIES.map((ind, i) => (
              <StaggerItem key={ind.title} className={i === 0 || i === 9 ? "lg:col-span-2" : ""}>
                <div className="card-surface group h-full" data-testid={`industry-card-${ind.title.toLowerCase().replace(/[\s&]+/g, "-")}`}>
                  <div className="flex items-start justify-between">
                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-blue-700/15 to-teal-500/15">
                      <ind.icon className="h-6 w-6 text-teal-500" />
                    </div>
                    <span className="font-display text-sm font-bold tracking-widest text-slate-900/10 transition-colors duration-500 group-hover:text-teal-500/40 dark:text-white/10">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="mt-5 font-display text-xl font-semibold tracking-tight">{ind.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{ind.desc}</p>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
          <Reveal className="mt-14 text-center">
            <p className="text-sm text-muted-foreground">Your industry is not listed? We have probably shipped for it anyway.</p>
            <Link to="/contact" className="btn-primary mt-6" data-testid="industries-cta">Discuss Your Sector <ArrowRight className="h-4 w-4" /></Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
